import React, { createContext, useContext, useEffect } from 'react';

interface SecurityContextType {
  // Add any security-related methods if needed in the future
}

const SecurityContext = createContext<SecurityContextType | undefined>(undefined);

export const useSecurity = () => {
  const context = useContext(SecurityContext);
  if (!context) {
    throw new Error('useSecurity must be used within a SecurityProvider');
  }
  return context;
};

interface SecurityProviderProps {
  children: React.ReactNode;
}

export const SecurityProvider: React.FC<SecurityProviderProps> = ({ children }) => {
  
  useEffect(() => {
    // TEMPORARILY DISABLED FOR TESTING - Re-enable by uncommenting below
    // Disable right-click context menu
    // const handleContextMenu = (e: MouseEvent) => {
    //   e.preventDefault();
    //   return false;
    // };

    // Disable common keyboard shortcuts
    const handleKeyDown = (e: KeyboardEvent) => {
      // TEMPORARILY DISABLED - Disable F12 (Developer Tools)
      // if (e.key === 'F12') {
      //   e.preventDefault();
      //   return false;
      // }
      
      // TEMPORARILY DISABLED - Disable Ctrl+Shift+I (Developer Tools)
      // if (e.ctrlKey && e.shiftKey && e.key === 'I') {
      //   e.preventDefault();
      //   return false;
      // }
      
      // TEMPORARILY DISABLED - Disable Ctrl+Shift+C (Element Inspector)
      // if (e.ctrlKey && e.shiftKey && e.key === 'C') {
      //   e.preventDefault();
      //   return false;
      // }
      
      // TEMPORARILY DISABLED - Disable Ctrl+Shift+J (Console)
      if (e.ctrlKey && e.shiftKey && e.key === 'J') {
        e.preventDefault();
        return false;
      }
      
      // Disable Ctrl+U (View Source)
      if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
        return false;
      }
      
      // Disable Ctrl+S (Save Page)
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
        return false;
      }
      
      // Disable Ctrl+A (Select All) - uncomment if needed
      // if (e.ctrlKey && e.key === 'a') {
      //   e.preventDefault();
      //   return false;
      // }
      
      // Disable Ctrl+P (Print) - uncomment if needed
      // if (e.ctrlKey && e.key === 'p') {
      //   e.preventDefault();
      //   return false;
      // }
    };

    // Disable drag and drop
    const handleDragStart = (e: DragEvent) => {
      e.preventDefault();
      return false;
    };

    // Disable text selection (optional - uncomment if needed)
    // const handleSelectStart = (e: Event) => {
    //   e.preventDefault();
    //   return false;
    // };

    // Add event listeners
    // TEMPORARILY DISABLED - document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('dragstart', handleDragStart);
    // document.addEventListener('selectstart', handleSelectStart);

    // Cleanup function
    return () => {
      // TEMPORARILY DISABLED - document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('dragstart', handleDragStart);
      // document.removeEventListener('selectstart', handleSelectStart);
    };
  }, []);

  // Prevent browser history manipulation
  useEffect(() => {
    // Replace current state instead of pushing to history
    const replaceHistory = () => {
      if (window.history.replaceState) {
        window.history.replaceState(null, '', window.location.href);
      }
    };

    // Clear browser history on load
    const clearHistory = () => {
      if (window.history.length > 1) {
        window.history.go(-(window.history.length - 1));
      }
    };

    // Override history methods
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function(data, title, url) {
      // Instead of pushing, replace the state
      originalReplaceState.call(window.history, data, title, url);
    };

    // Prevent back/forward navigation
    const handlePopState = (e: PopStateEvent) => {
      // Push the same state back to prevent navigation
      window.history.pushState(null, '', window.location.href);
    };

    window.addEventListener('popstate', handlePopState);

    // Initial setup
    replaceHistory();

    return () => {
      // Restore original methods
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  // Add additional security headers via meta tags
  useEffect(() => {
    // Prevent caching
    const addMetaTag = (name: string, content: string) => {
      const existingTag = document.querySelector(`meta[name="${name}"]`);
      if (existingTag) {
        existingTag.setAttribute('content', content);
      } else {
        const meta = document.createElement('meta');
        meta.name = name;
        meta.content = content;
        document.head.appendChild(meta);
      }
    };

    // Prevent caching
    addMetaTag('cache-control', 'no-cache, no-store, must-revalidate');
    addMetaTag('pragma', 'no-cache');
    addMetaTag('expires', '0');
    
    // Additional security headers
    addMetaTag('referrer', 'no-referrer');
    
  }, []);

  const value = {
    // Add any security-related methods here if needed
  };

  return (
    <SecurityContext.Provider value={value}>
      {children}
    </SecurityContext.Provider>
  );
};
